import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const AdmissionsComposedChart = ({ data }) => {
  return (
    <div className="bg-white p-2 md:p-6 rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-lg font-semibold pl-2 md:pl-0 mb-4">
        Admissions & Revenue
      </h3>
      <div className="h-60 md:h-80">
        <ResponsiveContainer>
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="patients" fill="#3B82F6" />
            <Line dataKey="revenue" stroke="#10B981" strokeWidth={3} />
            <ReferenceLine y={5000} stroke="red" label="Target" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AdmissionsComposedChart;